import { Button, Flex, LinkBox, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { sendClickLog, LogCategories } from 'libs/gtag';

const ContactLink = ({ title, href }: { title: string; href: string }) => (
  <LinkBox
    borderRadius="0.5rem"
    layerStyle="border"
    minHeight="6rem"
    textDecoration="none"
    _hover={{
      _hover: {
        backgroundColor: 'primary.200',
      },
    }}
    onClick={() => {
      sendClickLog({
        category: LogCategories.CONTACT,
        label: title,
      });
    }}
  >
    <Link href={href} passHref>
      <Flex
        direction={{
          base: 'column',
          md: 'column',
          lg: 'row',
        }}
        align="center"
        justify="space-between"
        padding="1.5rem"
      >
        <Text textStyle="body2" color="textGray.87" fontWeight={500}>
          {title}
        </Text>
        <Button
          marginX={{ base: '1.5rem', md: '1.5rem', lg: 0 }}
          marginTop={{ base: '1.5rem', md: '1.5rem', lg: 0 }}
          size="sm"
          height="3rem"
          width={{ base: '100%', md: '100%', lg: '10rem' }}
        >
          選択
        </Button>
      </Flex>
    </Link>
  </LinkBox>
);

export default ContactLink;
